import { PENDING_KNOCK_ENGAGEMENT_KEY, type PendingKnockEngagement } from "../types";

// Cold-start taps dispatch synchronously before useGetCurrentUser resolves
// the Knock JWT, so `interacted` events are queued to sessionStorage and
// drained once the JWT becomes available.
export function readPendingKnockEngagement(): PendingKnockEngagement[] {
  try {
    const raw = sessionStorage.getItem(PENDING_KNOCK_ENGAGEMENT_KEY);
    if (raw === null) {
      return [];
    }
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return [];
    }
    return parsed.filter(
      (entry: unknown): entry is PendingKnockEngagement =>
        typeof entry === "object" &&
        entry !== null &&
        typeof (entry as PendingKnockEngagement)?.knockMessageId === "string" &&
        ((entry as PendingKnockEngagement)?.status === "seen" ||
          (entry as PendingKnockEngagement)?.status === "interacted")
    );
  } catch {
    return [];
  }
}

export function appendPendingKnockEngagement(entry: PendingKnockEngagement): void {
  try {
    const existing = readPendingKnockEngagement();
    sessionStorage.setItem(PENDING_KNOCK_ENGAGEMENT_KEY, JSON.stringify([...existing, entry]));
  } catch {
    // sessionStorage may be unavailable
  }
}

export function clearPendingKnockEngagement(): void {
  try {
    sessionStorage.removeItem(PENDING_KNOCK_ENGAGEMENT_KEY);
  } catch {
    // sessionStorage may be unavailable
  }
}
